import axios from "axios";
import { baseUrl, portalUrl } from "./const";
let token = sessionStorage.getItem('TokenReguaPainel');

const api = {
    _baseUrl: baseUrl,
    _apiPortal: portalUrl,


    filtrarDados: function (pPosicao, pIdTipoChamado, pIdSetor, pIdQuarto, pIdLeito, pUsarPosicaoAberto, pUsarPosicaoAdministrativo, pUsarPosicaoFechado, pUsarPosicaoCancelado, pOrderData, pOrderHora, pData) {
        if (pIdTipoChamado == null) {
            pIdTipoChamado = 0;
        } else if (pIdTipoChamado == "Hotelaria") {
            pIdTipoChamado = 1;
        } else if (pIdTipoChamado == "Enfermagem") {
            pIdTipoChamado = 2;
        } else if (pIdTipoChamado == "Urg") {
            pIdTipoChamado = 3;
        }
        if (pIdSetor == null) {
            pIdSetor = 0;
        }
        if (pIdQuarto == null) {
            pIdQuarto = 0;
        }
        if (pIdLeito == null) {
            pIdLeito = 0;
        }
        // if (pUsarPosicaoAberto == null) {
        //     pUsarPosicaoAberto = false;
        // }
        // if (pUsarPosicaoAdministrativo == null) {
        //     pUsarPosicaoAdministrativo = false;
        // }
        // if (pUsarPosicaoFechado == null) {
        //     pUsarPosicaoFechado = false;
        // }
        // if (pUsarPosicaoCancelado == null) {
        //     pUsarPosicaoCancelado = false;
        // }
        if (pOrderData == ' ' || pOrderData == null) {
            pOrderData = 'desc';
        }
        if (pOrderHora == ' ' || pOrderHora == null) {
            pOrderHora = 'desc';
        }
        // console.log(pData);
        if (pData == '' || pData == null) {
            pData = '';
        }
        else {
            pData = '&pData=' + pData;
        }

        // console.log(`${this._baseUrl}/api/Chamado/listarDinamico?pPosicao=${pPosicao}&pIdTipoChamado=${pIdTipoChamado}&pIdSetor=${pIdSetor}&pIdQuarto=${pIdQuarto}&pIdLeito=${pIdLeito}&pOrderData=${pOrderData}&pOrderHora=${pOrderHora}${pData}`);

        // console.log(`/api/Chamado/listarDinamico?pPosicao=${pPosicao}&pIdTipoChamado=${pIdTipoChamado}&pIdSetor=${pIdSetor}&pIdQuarto=${pIdQuarto}&pIdLeito=${pIdLeito}&pOrderData=${pOrderData}&pOrderHora=${pOrderHora}${pData}`);

        // console.log(`${this._baseUrl}/api/Chamado/listarDinamico?
        // pPosicao=${pPosicao}
        // &pIdTipoChamado=${pIdTipoChamado}
        // &pIdSetor=${pIdSetor}
        // &pIdQuarto=${pIdQuarto}
        // &pIdLeito=${pIdLeito}
        // &pOrderData=${pOrderData}
        // &pOrderHora=${pOrderHora}
        // ${pData}
        // `);

        // &pUsarPosicaoAberto=${pUsarPosicaoAberto}
        // &pUsarPosicaoAdministrativo=${pUsarPosicaoAdministrativo}
        // &pUsarPosicaoFechado=${pUsarPosicaoFechado}
        // &pUsarPosicaoCancelado=${pUsarPosicaoCancelado}
        const request = axios.get(`${this._baseUrl}/api/Chamado/listarDinamico?pPosicao=${pPosicao}
        &pIdTipoChamado=${pIdTipoChamado}
        &pIdSetor=${pIdSetor}
        &pIdQuarto=${pIdQuarto}
        &pIdLeito=${pIdLeito}
        &pOrderData=${pOrderData}
        &pOrderHora=${pOrderHora}
        ${pData}
        `)
            .then(resposta => {
                // console.log(resposta.data);
                return resposta.data;
            })
            .catch(erro => {
                console.log("erro: " + erro);
            });

        return request;
    },
    carregaDadosChamado: function () {
        const request = axios.get(`${this._baseUrl}/api/Chamado/listar/`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    listarSetor: function () {
        const request = axios.get(`${this._baseUrl}/api/Setor/listar`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    finalizarAtendimento: function (id) {
        const request = axios.post(`${this._baseUrl}/api/Chamado/Finalizar?pIdChamado=${id}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    cancelarAtendimento: function (id) {
        const request = axios.post(`${this._baseUrl}/api/Chamado/Cancelar?pIdChamado=${id}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    listarTipoChamado: function () {
        const request = axios.get(`${this._baseUrl}/api/TipoChamado/listarPai`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    carregaConfig: function () {
        const request = axios.get(`${this._baseUrl}/api/Config/listar`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    tipoChamadoListarSub: function (pIdPrincipal) {
        const request = axios.get(`${this._baseUrl}/api/TipoChamado/listarSub?IdPrincipal=${pIdPrincipal}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    tipoChamadoExisteSub: function (pIdPrincipal) {
        const request = axios.get(`${this._baseUrl}/api/TipoChamado/ExisteSub?IdPrincipal=${pIdPrincipal}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    inserirDinamico: function (pUrl, pObjeto) {
        const request = axios.post(`${this._baseUrl}${pUrl}/inserir`, pObjeto, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));
        return request;
    },
    alterarDinamico: function (pUrl, pObjeto) {
        const request = axios.post(`${this._baseUrl}${pUrl}/alterar`, pObjeto, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    excluirDinamico: function (pUrl, pId) {
        const request = axios.post(`${this._baseUrl}${pUrl}/excluir?id=${pId}`, null, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    login: function (pLogin, pSenha) {
        console.log(`${this._baseUrl}/usuario/login?login=${pLogin}&senha=${pSenha}`);
        const request = axios.post(`${this._baseUrl}/usuario/login?login=${pLogin}&senha=${pSenha}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    listaDinamica: function (pUrl) {
        const request = axios.get(`${this._baseUrl}${pUrl}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    listarPorId: async function (pUrl, pId) {
        try {
            let response = await axios.get(`${this._baseUrl}${pUrl}/id?id=${pId}`);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    listarProfissional: function () {
        const request = axios.get(`${this._baseUrl}/api/profissional/listar`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    listarPorHQL: function () {
        const request = axios.get(`${this._baseUrl}/api/relatorio/listar?HQl=select c.Id, c.Data ,(c.HrFinalizacao - c.Hora), c.DtFinalizacao, c.TipoChamado.Descricao, c.Leito.Quarto.Setor.Descricao from Chamado c join fetch c.TipoChamado t join fetch c.Leito l join fetch l.Quarto q join fetch q.Setor s where c.DtFinalizacao <> null`, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(e => console.log(e));

        return request;
    },
    listarHQL: function (hql) {
        const request = axios.get(`${this._baseUrl}/api/relatorio/listar?HQl=${hql}`, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(e => console.log(e));

        return request;
    },
    listarEquipamento: function (ativos) {
        let where = "";
        if (ativos == true)
            where = "?exibirAtivos=true";
        else if (ativos == false)
            where = "?exibirAtivos=false";
        const request = axios.get(`${this._baseUrl}/api/equipamento/listar${where}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    listarEquipamentoPorId: function (pId) {
        const request = axios.get(`${this._baseUrl}/api/equipamento/id?id=${pId}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    listarEquipamentoPorNumSerie: function (pNumSerie) {
        const request = axios.get(`${this._baseUrl}/api/Equipamento/retornaEquipamento?pNumSerie=${pNumSerie}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    listarLeitoComChamado: function () {
        const request = axios.get(`${this._baseUrl}/api/Leito/listarComChamado`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));
        return request;
    },
    equipamentoStatus: function (pNumSerie, pBateria) {
        const request = axios.get(`${this._baseUrl}/api/Equipamento/statusEquipamento?pNumSerie=${pNumSerie}&pBateria=${pBateria}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    equipamentoChamar: function (pNumSerie, pBateria) {
        const request = axios.get(`${this._baseUrl}/api/Equipamento/chamadoEquipamento?pNumSerie=${pNumSerie}&pBateria=${pBateria}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    chamadoLimpar: function () {
        const request = axios.post(`${this._baseUrl}/api/Chamado/Limpar`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    chamadoLimparLeito: function (pMotivo, pIdLeito) {
        const request = axios.post(`${this._baseUrl}/api/Chamado/Limpar?pMotivo=${pMotivo}&pIdLeito=${pIdLeito}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    listarSql: function (pSql) {
        const request = axios.get(`${this._baseUrl}/api/Relatorio/listarSQL?sql=${pSql}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    listarSqlPortal: function (pSql) {
        const request = axios.get(`${this._apiPortal}/api/Relatorio/listarSQL?sql=${pSql}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    transferir: function (pIdTipoChamado, pMotivo) {
        const request = axios.post(`${this._baseUrl}/api/Chamado/Transferir?pIdChamado=${pIdTipoChamado}&pMotivo=${pMotivo}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },

    //#region  INTERNAÇÃO
    InternacaoListar: function () {
        const request = axios.get(`${this._apiPortal}/api/Internacao/Listar`)
            // const request = axios.get(`${this._baseUrl}/api/Internacao/Listar`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoListarPorId: function (pIdInternacao, pSemAlta = true) {
        const request = axios.get(`${this._apiPortal}/api/Internacao/ListarPorId?pIdInternacao=${pIdInternacao}&pSemAlta=${pSemAlta}`)
            // const request = axios.get(`${this._baseUrl}/api/Internacao/ListarPorId?pIdInternacao=${pIdInternacao}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoListarPorIdPaciente: function (pIdPaciente) {
        const request = axios.get(`${this._apiPortal}/api/Internacao/ListarPorPaciente?pIdPaciente=${pIdPaciente}`)
            // const request = axios.get(`${this._baseUrl}/api/Internacao/ListarPorPaciente?pIdPaciente=${pIdPaciente}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoInserir: function (pObjInternacao) {
        const request = axios.post(`${this._apiPortal}/api/Internacao/Inserir`, pObjInternacao, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/Internacao/Inserir`, pObjInternacao, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoAlterar: function (pObjInternacao) {
        const request = axios.post(`${this._apiPortal}/api/Internacao/Alterar`, pObjInternacao, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/Internacao/Alterar`, pObjInternacao, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoExcluir: function (pIdInternacao) {
        const request = axios.post(`${this._apiPortal}/api/Internacao/Excluir?id=${pIdInternacao}`)
            // const request = axios.post(`${this._baseUrl}/api/Internacao/Excluir?id=${pIdInternacao}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    //#endregion

    //#region  INTERNAÇÃO ARQUIVO 
    InternacaoArqListar: function () {
        const request = axios.get(`${this._apiPortal}/api/InternacaoArq/Listar`)
            // const request = axios.get(`${this._baseUrl}/api/InternacaoArq/Listar`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoArqListarPorIdInternacao: function (pIdInternacao) {
        const request = axios.get(`${this._apiPortal}/api/InternacaoArq/ListarPorIdInternacao?pIdInternacaoArq=${pIdInternacao}`)
            // const request = axios.get(`${this._baseUrl}/api/InternacaoArq/ListarPorIdInternacao?pIdInternacaoArq=${pIdInternacao}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoArqListarPorIdPaciente: function (pIdPaciente) {
        const request = axios.get(`${this._apiPortal}/api/InternacaoArq/ListarPorIdPaciente?pIdPaciente=${pIdPaciente}`)
            // const request = axios.get(`${this._baseUrl}/api/InternacaoArq/ListarPorIdPaciente?pIdPaciente=${pIdPaciente}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoArqInserir: function (pObjInternacaoArq) {
        const request = axios.post(`${this._apiPortal}/api/InternacaoArq/Inserir`, pObjInternacaoArq, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/InternacaoArq/Inserir`, pObjInternacaoArq, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoArqAlterar: function (pObjInternacaoArq) {
        const request = axios.post(`${this._apiPortal}/api/InternacaoArq/Alterar`, pObjInternacaoArq, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/InternacaoArq/Alterar`, pObjInternacaoArq, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoArqExcluir: function (pIdInternacaoArq) {
        const request = axios.post(`${this._apiPortal}/api/InternacaoArq/Excluir?id=${pIdInternacaoArq}`)
            // const request = axios.post(`${this._baseUrl}/api/InternacaoArq/Excluir?id=${pIdInternacaoArq}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    //#endregion

    //#region  INTERNAÇÃO ARQUIVO ITEM 
    InternacaoArqItemListar: function () {
        const request = axios.get(`${this._apiPortal}/api/InternacaoArqItem/Listar`)
            // const request = axios.get(`${this._baseUrl}/api/InternacaoArqItem/Listar`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoArqItemListarPorIdInternacao: function (pIdInternacao) {
        const request = axios.get(`${this._apiPortal}/api/InternacaoArqItem/ListarPorIdInternacao?pIdInternacaoArq=${pIdInternacao}`)
            // const request = axios.get(`${this._baseUrl}/api/InternacaoArqItem/ListarPorIdInternacao?pIdInternacaoArq=${pIdInternacao}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoArqItemListarPorIdPaciente: function (pIdPaciente) {
        const request = axios.get(`${this._apiPortal}/api/InternacaoArqItem/ListarPorIdPaciente?pIdPaciente=${pIdPaciente}`)
            // const request = axios.get(`${this._baseUrl}/api/InternacaoArqItem/ListarPorIdPaciente?pIdPaciente=${pIdPaciente}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoArqItemInserir: function (pObjInternacaoArq) {
        const request = axios.post(`${this._apiPortal}/api/InternacaoArqItem/Inserir`, pObjInternacaoArq, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/InternacaoArqItem/Inserir`, pObjInternacaoArq, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoArqItemAlterar: function (pObjInternacaoArq) {
        const request = axios.post(`${this._apiPortal}/api/InternacaoArqItem/Alterar`, pObjInternacaoArq, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/InternacaoArqItem/Alterar`, pObjInternacaoArq, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    InternacaoArqItemExcluir: function (pIdInternacaoArq) {
        const request = axios.post(`${this._apiPortal}/api/InternacaoArqItem/Excluir?id=${pIdInternacaoArq}`)
            // const request = axios.post(`${this._baseUrl}/api/InternacaoArqItem/Excluir?id=${pIdInternacaoArq}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    //#endregion

    //#region  PACIENTE
    PacienteListar: function () {
        const request = axios.get(`${this._baseUrl}/api/Paciente/Listar`)
            // const request = axios.get(`${this._baseUrl}/api/Paciente/Listar`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    PacienteListarPorId: function (pIdPaciente) {
        const request = axios.get(`${this._baseUrl}/api/Paciente/ListarPorId?pIdPaciente=${pIdPaciente}`)
            // const request = axios.get(`${this._baseUrl}/api/Paciente/ListarPorId?pIdPaciente=${pIdPaciente}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    PacienteInserir: function (pObjPaciente) {
        const request = axios.post(`${this._baseUrl}/api/Paciente/Inserir`, pObjPaciente, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/Paciente/Inserir`, pObjPaciente, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    PacienteAlterar: function (pObjPaciente) {
        const request = axios.post(`${this._baseUrl}/api/Paciente/Alterar`, pObjPaciente, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/Paciente/Alterar`, pObjPaciente, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    PacienteExcluir: function (pIdPaciente) {
        const request = axios.post(`${this._baseUrl}/api/Paciente/Excluir?id=${pIdPaciente}`)
            // const request = axios.post(`${this._baseUrl}/api/Paciente/Excluir?id=${pIdPaciente}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    //#endregion

    //#region  TIPO FOTO
    TipoFotoListar: function () {
        const request = axios.get(`${this._baseUrl}/api/TipoFoto/listar`)
            // const request = axios.get(`${this._baseUrl}/api/TipoFoto/listar`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));
        return request;
    },
    TipoFotoListarId: function (pIdTipo) {
        const request = axios.get(`${this._baseUrl}/api/TipoFoto/id?id=${pIdTipo}`)
            // const request = axios.get(`${this._baseUrl}/api/TipoFoto/id?id=${pIdTipo}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));
        return request;
    },
    TipoFotoInserir: function (pObjTipoFoto) {
        const request = axios.post(`${this._baseUrl}/api/TipoFoto/Inserir`, pObjTipoFoto, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/TipoFoto/Inserir`, pObjTipoFoto, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(e => console.log(e));
        return request;
    },
    TipoFotoAlterar: function (pObjTipoFoto) {
        const request = axios.post(`${this._baseUrl}/api/TipoFoto/Alterar`, pObjTipoFoto, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/TipoFoto/Alterar`, pObjTipoFoto, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(e => console.log(e));
        return request;
    },
    TipoFotoExcluir: function () {
        const request = axios.post(`${this._baseUrl}/api/TipoFoto/Excluir`, null, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/TipoFoto/Excluir`, null, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(e => console.log(e));
        return request;
    },
    //#endregion

    //#region  TIPO ATENDIMENTO
    TipoAtendimentoListar: function () {
        const request = axios.get(`${this._baseUrl}/api/TipoAtendimento/listar`)
            // const request = axios.get(`${this._baseUrl}/api/TipoAtendimento/listar`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));
        return request;
    },
    TipoAtendimentoListarId: function (pIdTipo) {
        const request = axios.get(`${this._baseUrl}/api/TipoAtendimento/id?id=${pIdTipo}`)
            // const request = axios.get(`${this._baseUrl}/api/TipoAtendimento/id?id=${pIdTipo}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));
        return request;
    },
    TipoAtendimentoInserir: function (pObjTipoAtendimento) {
        const request = axios.post(`${this._baseUrl}/api/TipoAtendimento/Inserir`, pObjTipoAtendimento, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/TipoAtendimento/Inserir`, pObjTipoAtendimento, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(e => console.log(e));
        return request;
    },
    TipoAtendimentoAlterar: function (pObjTipoAtendimento) {
        const request = axios.post(`${this._baseUrl}/api/TipoAtendimento/Alterar`, pObjTipoAtendimento, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/TipoAtendimento/Alterar`, pObjTipoAtendimento, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(e => console.log(e));
        return request;
    },
    TipoAtendimentoExcluir: function () {
        const request = axios.post(`${this._baseUrl}/api/TipoAtendimento/Excluir`, null, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/TipoAtendimento/Excluir`, null, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(e => console.log(e));
        return request;
    },
    //#endregion

    //#region  SUB TIPO ATENDIMENTO
    SubTipoAtendimentoListar: function () {
        const request = axios.get(`${this._baseUrl}/api/SubTipoAtendimento/listar`)
            // const request = axios.get(`${this._baseUrl}/api/SubTipoAtendimento/listar`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));
        return request;
    },
    SubTipoAtendimentoListarId: function (pIdSubTipo) {
        const request = axios.get(`${this._baseUrl}/api/SubTipoAtendimento/id?id=${pIdSubTipo}`)
            // const request = axios.get(`${this._baseUrl}/api/SubTipoAtendimento/id?id=${pIdSubTipo}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));
        return request;
    },
    SubTipoAtendimentoListarPorIdTipoAtendimento: function (pIdSubTipo) {
        const request = axios.get(`${this._baseUrl}/api/SubTipoAtendimento/idTipoAtendimento?id=${pIdSubTipo}`)
            // const request = axios.get(`${this._baseUrl}/api/SubTipoAtendimento/idTipoAtendimento?id=${pIdSubTipo}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));
        return request;
    },
    SubTipoAtendimentoInserir: function (pObjSubTipoAtendimento) {
        const request = axios.post(`${this._baseUrl}/api/SubTipoAtendimento/Inserir`, pObjSubTipoAtendimento, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/SubTipoAtendimento/Inserir`, pObjSubTipoAtendimento, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(e => console.log(e));
        return request;
    },
    SubTipoAtendimentoAlterar: function (pObjSubTipoAtendimento) {
        const request = axios.post(`${this._baseUrl}/api/SubTipoAtendimento/Alterar`, pObjSubTipoAtendimento, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/SubTipoAtendimento/Alterar`, pObjSubTipoAtendimento, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(e => console.log(e));
        return request;
    },
    SubTipoAtendimentoExcluir: function () {
        const request = axios.post(`${this._baseUrl}/api/SubTipoAtendimento/Excluir`, null, { headers: { Authorization: `Bearer ${token}` } })
            // const request = axios.post(`${this._baseUrl}/api/SubTipoAtendimento/Excluir`, null, { headers: { Authorization: `Bearer ${token}` } })
            .then(resposta => { return resposta.data; })
            .catch(e => console.log(e));
        return request;
    },
    //#endregion

    //#region RELATORIOS
    GerarRelatorioAtendimentoAoLongoTempo: function (pDiaInicial, pDiaFinal, pTempo, pIdChamado, pIdSetor) {
        if (typeof pDiaInicial != "string") { pDiaInicial = ""; }
        if (typeof pDiaFinal != "string") { pDiaFinal = ""; }
        if (typeof pTempo != "string") { pTempo = ""; }
        if (typeof pIdChamado != "number") { pIdChamado = 0; }
        if (typeof pIdSetor != "number") { pIdSetor = 0; }
        const request = axios.get(`${this._baseUrl}/api/FastReport/GerarRelatorioAtendimentoAoLongoTempo?pDiaInicial=${pDiaInicial}&pDiaFinal=${pDiaFinal}&pTempo=${pTempo}&pIdChamado=${pIdChamado}&pIdSetor=${pIdSetor}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    GerarRelatorioHistoricoGeral: function (pDiaInicial, pDiaFinal, pTempo, pIdChamado, pIdSetor) {
        if (typeof pDiaInicial != "string") { pDiaInicial = ""; }
        if (typeof pDiaFinal != "string") { pDiaFinal = ""; }
        if (typeof pTempo != "string") { pTempo = ""; }
        if (typeof pIdChamado != "number") { pIdChamado = 0; }
        if (typeof pIdSetor != "number") { pIdSetor = 0; }
        const request = axios.get(`${this._baseUrl}/api/FastReport/GerarRelatorioHistoricoGeral?pDiaInicial=${pDiaInicial}&pDiaFinal=${pDiaFinal}&pTempo=${pTempo}&pIdChamado=${pIdChamado}&pIdSetor=${pIdSetor}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    GerarRelatorioSatisfacaoCliente: function (pDiaInicial, pDiaFinal, pTempo, pIdChamado, pIdSetor) {
        if (typeof pDiaInicial != "string") { pDiaInicial = ""; }
        if (typeof pDiaFinal != "string") { pDiaFinal = ""; }
        if (typeof pTempo != "string") { pTempo = ""; }
        if (typeof pIdChamado != "number") { pIdChamado = 0; }
        if (typeof pIdSetor != "number") { pIdSetor = 0; }
        const request = axios.get(`${this._baseUrl}/api/FastReport/GerarRelatorioSatisfacaoCliente?pDiaInicial=${pDiaInicial}&pDiaFinal=${pDiaFinal}&pTempo=${pTempo}&pIdChamado=${pIdChamado}&pIdSetor=${pIdSetor}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    GerarRelatorioTempoAtendimento: function (pDiaInicial, pDiaFinal, pTempo, pIdChamado, pIdSetor) {
        if (typeof pDiaInicial != "string") { pDiaInicial = ""; }
        if (typeof pDiaFinal != "string") { pDiaFinal = ""; }
        if (typeof pTempo != "string") { pTempo = ""; }
        if (typeof pIdChamado != "number") { pIdChamado = 0; }
        if (typeof pIdSetor != "number") { pIdSetor = 0; }
        const request = axios.get(`${this._baseUrl}/api/FastReport/GerarRelatorioTempoAtendimento?pDiaInicial=${pDiaInicial}&pDiaFinal=${pDiaFinal}&pTempo=${pTempo}&pIdChamado=${pIdChamado}&pIdSetor=${pIdSetor}`)
            .then(resposta => { return resposta.data; })
            .catch(erro => console.log(erro));

        return request;
    },
    //#endregion
};
export default api;